var installedModules = {};
var moduleToHandlerMapping = {
	9147: {
		getter: () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(3443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "auto",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/remote-utils",
	},
	8025: {
		getter: () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(519)]).then(() => (() => (__webpack_require__(6519))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/shared-web-components",
	},
	8511: {
		getter: () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(780)]).then(() => (() => (__webpack_require__(5399))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/sudoku-web-components",
	},
	1819: {
		getter: () => (__webpack_require__.e(156).then(() => (() => (__webpack_require__(4156))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/sudoku-services",
	},
	9765: {
		getter: () => (__webpack_require__.e(493).then(() => (() => (__webpack_require__(6493))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cv-mf/sudoku-types",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"185": [
		9147,
		8025,
		8511,
		1819,
		9765
	],
	"399": [
		1819,
		9765
	],
	"775": [
		9765
	],
	"936": [
		9147,
		8025,
		8511,
		1819,
		9765
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}